import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { GROUPS, TRIAL_WA } from "../data/content";

export const TrainingGroups = () => (
  <section id="training-groups" className="py-24 sm:py-32 scroll-mt-16" data-testid="training-groups-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <Reveal>
        <Overline>Our Training Groups</Overline>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-3 max-w-3xl">
          A group for every <span className="text-[#D4AF37]">stage.</span>
        </h2>
        <p className="mt-4 text-white/60 text-[15px] max-w-2xl">Find the development environment that fits your child today — and the next one they'll grow into.</p>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 gap-4 sm:gap-5">
        {GROUPS.map((g, i) => (
          <Reveal key={g.name} delay={i * 0.06}>
            <article className="border border-white/10 bg-[#050505] p-6 sm:p-8 h-full hover:border-[#D4AF37]/40 hover:bg-[#0A0A0A] transition-all duration-300 flex flex-col"
                     data-testid={`group-${g.name.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="font-heading text-2xl font-black uppercase tracking-tight">{g.name}</h3>
                  <p className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] font-bold mt-1">{g.ages}</p>
                </div>
                <span className="font-heading text-3xl font-black text-white/15 leading-none">0{i + 1}</span>
              </div>
              <p className="text-white/70 text-sm mt-4 leading-relaxed">{g.audience}</p>
              <ul className="mt-5 space-y-1.5">
                {g.focusList.map((f) => (
                  <li key={f} className="text-white/50 text-sm flex items-start gap-2">
                    <span className="text-[#D4AF37] mt-1.5 shrink-0 w-1 h-1 bg-[#D4AF37]" /> {f}
                  </li>
                ))}
              </ul>
              <div className="mt-6 pt-6 border-t border-white/8 flex gap-3">
                {g.link ? (
                  <Link to={g.link} className="text-[#D4AF37] text-xs font-bold uppercase tracking-widest inline-flex items-center gap-1.5 hover:gap-2 transition-all" data-testid={`group-explore-${g.name.toLowerCase()}`}>
                    Explore {g.name} <ArrowRight size={13} />
                  </Link>
                ) : (
                  <a href={TRIAL_WA} target="_blank" rel="noreferrer"
                    className="text-[#D4AF37] text-xs font-bold uppercase tracking-widest inline-flex items-center gap-1.5 hover:gap-2 transition-all" data-testid={`group-trial-${g.name.toLowerCase()}`}>
                    Book a Trial <ArrowRight size={13} />
                  </a>
                )}
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.4}>
        <div className="mt-14 text-center border border-white/10 bg-[#050505] p-6 sm:p-8">
          <p className="text-white/60 text-sm max-w-xl mx-auto">Not sure which group is right? Chat with us — we'll help you place your child correctly.</p>
          <a href={TRIAL_WA} target="_blank" rel="noreferrer"
            className="mt-4 inline-flex items-center gap-2 border border-[#D4AF37] text-[#D4AF37] font-bold uppercase tracking-widest text-xs px-5 py-2.5 hover:bg-[#D4AF37] hover:text-black transition-colors duration-200"
            data-testid="training-groups-help">
            <MessageCircle size={13} /> Get Personalised Advice
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
